import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MeetingUserAvailabilityOverrideResponse } from '../models/meeting.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface AvailabilityOverrideDrawerOptions {
  overrideId?: number;
  idUser?: number;
}

@Injectable({ providedIn: 'root' })
export class MeetingAvailabilityOverrideDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: AvailabilityOverrideDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly saved$$ = new Subject<MeetingUserAvailabilityOverrideResponse>();

  readonly state = this.state$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(options: AvailabilityOverrideDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(item: MeetingUserAvailabilityOverrideResponse): void {
    this.saved$$.next(item);
  }
}
